var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_filter_3629722",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35560",
    "data-name": "Group 35560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35559",
    "data-name": "Group 35559",
    transform: "translate(-632 -125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64098",
    "data-name": "Path 64098",
    d: "M641,135a1,1,0,0,1,0,2h-2a1,1,0,0,1,0-2h2Zm3-5a1,1,0,0,1,0,2h-8a1,1,0,0,1,0-2h8Zm3-5a1,1,0,0,1,0,2H633a1,1,0,0,1,0-2h14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconBlack);
export default __webpack_public_path__ + "static/media/filter_icon_black.aa1bc4a5fad6ae0da57b1f1e7cf45695.svg";
export { ForwardRef as ReactComponent };